import React from "react";
import "../styles/Banner.css";
import { useLanguage } from "../contexts/LanguageContext";

const Banner = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const b = text.banner;
  const bookingUrl = text.contactDetails.bookingUrl || "#contact";

  return (
    <section className="banner-section" dir={isHeb ? "rtl" : "ltr"}>
      <div className="banner-card">
        <div className="banner-glow" aria-hidden="true" />
        <div className="banner-copy">
          <h3 className="banner-title">{b.title}</h3>
          <p className="banner-desc">{b.desc}</p>
        </div>
        <a
          className="btn btn-primary banner-cta"
          href={bookingUrl}
          target={bookingUrl.startsWith("http") ? "_blank" : undefined}
          rel="noopener noreferrer"
        >
          {b.cta}
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Banner;
